import React from 'react';
import { colors, spacing, shadows, typography } from '../tokens';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Modal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    title = _ref.title,
    children = _ref.children;
  if (!isOpen) return null;
  var overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'var(--bafkal-overlay)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
  };
  var modalStyle = {
    fontFamily: typography.fontFamily,
    backgroundColor: 'var(--bafkal-bg-surface)',
    borderRadius: '12px',
    boxShadow: shadows.lg,
    padding: spacing.xl,
    maxWidth: '500px',
    width: '90%',
    maxHeight: '90vh',
    overflowY: 'auto'
  };
  var headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing.md,
    borderBottom: "1px solid ".concat(colors.neutral[200]),
    paddingBottom: spacing.sm
  };
  var closeButtonStyle = {
    background: 'none',
    border: 'none',
    fontSize: '1.25rem',
    cursor: 'pointer',
    color: colors.neutral[500]
  };
  return /*#__PURE__*/_jsx("div", {
    style: overlayStyle,
    onClick: onClose,
    children: /*#__PURE__*/_jsxs("div", {
      style: modalStyle,
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      children: [/*#__PURE__*/_jsxs("div", {
        style: headerStyle,
        children: [title && /*#__PURE__*/_jsx("h3", {
          style: {
            margin: 0,
            fontSize: typography.sizes.lg
          },
          children: title
        }), /*#__PURE__*/_jsx("button", {
          style: closeButtonStyle,
          onClick: onClose,
          children: "\xD7"
        })]
      }), /*#__PURE__*/_jsx("div", {
        children: children
      })]
    })
  });
}